import { AutogenModelBrokerageTrackingCtrl, AutogenRowBrokerageTrackingCtrl } from "./autogen/AutogenModelBrokerageTrackingCtrl";

export class ModelBrokerageTrackingCtrl extends AutogenModelBrokerageTrackingCtrl<RowBrokerageTrackingCtrl> {
    constructor() {
        super(RowBrokerageTrackingCtrl);
    }
}

export class RowBrokerageTrackingCtrl extends AutogenRowBrokerageTrackingCtrl {
}